import TransactionsItems from "../../../../../hocs/pettyCashTransactions";
import {
  PettyCashierPaymentAction,
  PettyCashierPettyCashAction,
  PettyCashierReceiveAction
} from "../../../../../actions";
import { REDUCER_NAMES } from "../../../../../constants/reducerNames";
import DisplayImageByNumber from "../../../../../lib/components/displayImageByNumber";
import NumberDisplay from "../../../../../components/imageSlider/numberDisplay";
import { REDUCER } from "../../../../../constants/widelyUsedReducersName";

const PaymentImage = DisplayImageByNumber(NumberDisplay, {
  reducer_name: REDUCER.PETTY_CASHIER.PAYMENT,
  getItem: id => PettyCashierPaymentAction.getImageRequest(id)
});

const ReceiveImage = DisplayImageByNumber(NumberDisplay, {
  reducer_name: REDUCER.PETTY_CASHIER.RECEIVE,
  getItem: id => PettyCashierReceiveAction.getImageRequest(id)
});

const ByDetails = TransactionsItems({
  reducer_name: REDUCER_NAMES.SUMMARY.PETTY_CASHIER.PETTY_CASH,
  getItems: PettyCashierPettyCashAction.getItemsRequest,
  PaymentImage: PaymentImage,
  ReceiveImage: ReceiveImage
});

export default ByDetails;
